module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list smart-hr-roster"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("智能人事")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("员工管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("花名册")])], 1)], 1), _vm._v(" "), _c('Alert', {
    staticClass: "tip",
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n    数据从钉钉同步到本后台；在本后台新增/修改/导入导出不会写回钉钉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('Form', {
    attrs: {
      "label-width": 70,
      "show-message": false,
      "inline": ""
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.query.empStatus),
      callback: function($$v) {
        _vm.$set(_vm.query, "empStatus", $$v)
      },
      expression: "query.empStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("在职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DIMISSION"
    }
  }, [_vm._v("已离职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PREHIRE"
    }
  }, [_vm._v("待入职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "关键字"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "姓名/手机/工号/钉钉ID"
    },
    on: {
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.query.keyword),
      callback: function($$v) {
        _vm.$set(_vm.query, "keyword", $$v)
      },
      expression: "query.keyword"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "left-btn"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.syncing
    },
    on: {
      "click": _vm.doSync
    }
  }, [_vm._v("从钉钉同步")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openAdd
    }
  }, [_vm._v("本地新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-btn"
  }, [_c('Button', {
    attrs: {
      "loading": _vm.tplLoading
    },
    on: {
      "click": _vm.doTemplate
    }
  }, [_vm._v("下载导入模板")]), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "8px"
    },
    attrs: {
      "before-upload": _vm.beforeImport,
      "show-upload-list": false,
      "action": "",
      "accept": ".xlsx,.xls"
    }
  }, [_c('Button', {
    attrs: {
      "loading": _vm.importing
    }
  }, [_vm._v("导入（仅本地）")])], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), (_vm.syncMsg) ? _c('div', {
    staticClass: "sync-msg"
  }, [_vm._v(_vm._s(_vm.syncMsg))]) : _vm._e(), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.rows,
      "loading": _vm.loading,
      "stripe": "",
      "no-data-text": "暂无员工，请先从钉钉同步"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.query.pageIndex,
      "page-size": _vm.query.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPage,
      "on-page-size-change": _vm.onSize
    }
  })], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "员工详情",
      "mask-closable": false,
      "width": "640",
      "footer-hide": true
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [(_vm.detail) ? _c('div', [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.name),
      callback: function($$v) {
        _vm.$set(_vm.edit, "name", $$v)
      },
      expression: "edit.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "手机"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.mobile),
      callback: function($$v) {
        _vm.$set(_vm.edit, "mobile", $$v)
      },
      expression: "edit.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "工号"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.jobNumber),
      callback: function($$v) {
        _vm.$set(_vm.edit, "jobNumber", $$v)
      },
      expression: "edit.jobNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "职位"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.position),
      callback: function($$v) {
        _vm.$set(_vm.edit, "position", $$v)
      },
      expression: "edit.position"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.edit.deptNames),
      callback: function($$v) {
        _vm.$set(_vm.edit, "deptNames", $$v)
      },
      expression: "edit.deptNames"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.edit.empStatus),
      callback: function($$v) {
        _vm.$set(_vm.edit, "empStatus", $$v)
      },
      expression: "edit.empStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("在职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DIMISSION"
    }
  }, [_vm._v("已离职")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PREHIRE"
    }
  }, [_vm._v("待入职")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.edit.source === 'LOCAL' || _vm.edit.localDirty === 1 ? '本地维护' : '钉钉同步'))])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveLocal
    }
  }, [_vm._v("保存（仅本地）")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        _vm.drawer = false
      }
    }
  }, [_vm._v("关闭")])], 1), _vm._v(" "), _c('Divider', [_vm._v("花名册字段")]), _vm._v(" "), (!(_vm.detail.fields && _vm.detail.fields.length)) ? _c('div', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("暂无字段数据")]) : _c('Table', {
    attrs: {
      "size": "small",
      "columns": _vm.fieldColumns,
      "data": _vm.detail.fields
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "本地新增员工（不写回钉钉）"
    },
    on: {
      "on-ok": _vm.addLocal
    },
    model: {
      value: (_vm.showAdd),
      callback: function($$v) {
        _vm.showAdd = $$v
      },
      expression: "showAdd"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "姓名",
      "required": ""
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "手机"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "工号"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.jobNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "jobNumber", $$v)
      },
      expression: "addForm.jobNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "职位"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.position),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "position", $$v)
      },
      expression: "addForm.position"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.addForm.deptNames),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deptNames", $$v)
      },
      expression: "addForm.deptNames"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1acc4acf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/smartHr/SmartHrRoster.vue
// module id = 1660
// module chunks = 8